import React, { useState } from 'react';
import styled from 'styled-components';

const Gallery = styled.div`
  margin-bottom: 3rem;
`;

const MainImageWrapper = styled.div`
  width: 100%;
  background: #f7f7f7;
  border-radius: 12px;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const MainImage = styled.img`
  max-width: 100%;
  max-height: 600px;
  object-fit: contain;
  border-radius: 10px;
`;

const Thumbnails = styled.div`
  margin-top: 1rem;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));
  gap: 10px;
`;

const Thumb = styled.img`
  width: 100%;
  height: 70px;
  object-fit: cover;
  border-radius: 8px;
  cursor: pointer;
  opacity: ${props => props.active ? 1 : 0.6};
  border: ${props => props.active ? "2px solid #2f6fad" : "2px solid transparent"};

  &:hover {
    opacity: 1;
  }
`;

const ImageGallery = ({ images }) => {

  const [active, setActive] = useState(0);

  return (
    <Gallery>

      <MainImageWrapper>
        <MainImage
          src={images[active]}
          alt="Apartament"
        />
      </MainImageWrapper>

      <Thumbnails>

        {images.map((img, index) => (
          <Thumb
            key={index}
            src={img}
            active={index === active}
            onClick={() => setActive(index)}
          />
        ))}

      </Thumbnails>

    </Gallery>
  );
};

export default ImageGallery;